module.exports = __webpack_public_path__ + "img/door_controller_urmet.3e3f9320.png";